import type { HTMLAttributes, ReactNode } from "react"

export function CardSection({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLElement> & { children: ReactNode }) {
  return (
    <section className={["card-section", className].filter(Boolean).join(" ")} {...props}>
      {children}
    </section>
  )
}
